import type { DerivedTag } from '@/lib/noteTags';
import { cn } from '@/lib/utils';

interface TagBadgeProps {
  tag: DerivedTag;
  className?: string;
}

/**
 * A classification label on a record card: a small hairline-ruled pill, in the
 * same soft, rounded language as the rest of the archive. (Cards are themselves
 * links, so the label is plain text; the record page offers linked terms.)
 */
export function TagBadge({ tag, className }: TagBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-foreground/20 bg-transparent px-2 py-0.5',
        'font-engraved text-[9px] font-semibold uppercase leading-none tracking-[0.12em] text-foreground/70',
        className,
      )}
    >
      {tag.label}
    </span>
  );
}
